module.exports = __webpack_public_path__ + "img/output_sun_pump.4656bd57.png";